import React, { Component } from 'react';
import { Link } from 'react-router';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import { getSetsMasterGroup } from '../../utils/db';
import Bugsnag from '../../helpers/bugsnag';

class Components extends Component {
  constructor(props) {
    super(props);

    this.state = { setGroup: [] };
  }

  _onSelectedGroup = (selectedData, index = null) => {
    try {
      const { onSelectedSetsGroup } = this.props;
      const { active } = this.state;
      if (active === index) {
        this.setState({ active: null });
      } else {
        onSelectedSetsGroup(selectedData);
        this.setState({ active: index });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onSelectedSetsGroup = (position) => {
    try {
      const { active } = this.state;
      if (active === position) {
        return 'selected';
      }
      return '';
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  async UNSAFE_componentWillMount() {
    try {
      const { caseType, setInfo } = this.props;
      const setGroupData = {};
      const setGroup = await getSetsMasterGroup();
      if (setInfo) {
        setGroup.map((item) => {
          if (!setGroupData.hasOwnProperty(item.CaseType)) {
            setGroupData[item.CaseType] = [];
          }
          setGroupData[item.CaseType].push(item);
        });
        setGroup && this.setState({ setGroup: setGroupData });
      } else {
        const caseTypeFilter = setGroup.filter((item) => item.CaseType === caseType.toString());
        caseTypeFilter.map((item) => {
          if (!setGroupData.hasOwnProperty(item.CaseType)) {
            setGroupData[item.CaseType] = [];
          }
          setGroupData[item.CaseType].push(item);
        });
        setGroup && this.setState({ setGroup: setGroupData });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const { setGroup } = this.state;
    return (
      <section>
        <section className="section">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="sets-list-blocks t-b-border-0 mt-1">
                  {
                    Object.keys(setGroup).length > 0
                      ? Object.keys(setGroup).map((value, index) => (
                        <div className="sets-block" key={index}>
                          <h4><span>{value}</span></h4>
                          <ul className="select-list list-unstyled cursor-pointer">
                            {
                              setGroup[value].map((data, key) => (
                                <Link
                                  onClick={() => { this._onSelectedGroup(data, index); }} key={key}
                                >
                                  <li className={this._onSelectedSetsGroup(index)} style={{ borderBottom: '1px solid #424242' }}>
                                    {data.SetGroup} {
                                    (data.SetCnt > 1)
                                      ? `(${data.SetCnt} Sets)`
                                      : (data.SetCnt !== null)
                                        ? `(${data.SetCnt} Set)`
                                        : `(${data.SetCnt === null ? 0 : ''} Set)`
                                  }
                                  </li>
                                </Link>
                              ))
                            }
                          </ul>
                        </div>
                      )) : <p className="text-center">No sets group match to your filters</p>
                  }
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    );
  }
}

export default withNotify(withLoader(Components));
